import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import { useMutation } from "react-query";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { useEffect, useState } from "react";

import { updateUserLegalName } from "../../../services/userServices";

import styles from "./index.module.scss";

interface IUpdateLegalNameModal {
  fullName: string;
  isVisible: boolean;
  onClose: () => void;
  onSuccess: () => void;
}

export default function UpdateLegalNameModal({
  fullName,
  onClose,
  onSuccess,
  isVisible = false,
}: IUpdateLegalNameModal) {
  const { userId } = useParams();
  const [name, setName] = useState(fullName || "");

  useEffect(() => {
    if (isVisible) {
      setName(fullName || "");
    }
  }, [isVisible, fullName]);

  const updateMutation = useMutation({
    mutationFn: () => updateUserLegalName(userId || "", name.trim()),
    onSuccess: () => {
      toast.success("Legal name updated successfully");
      onSuccess();
      onClose();
    },
    onError: (error: Error) => {
      toast.error(
        `An error happened. Please reach out to the engineering team with the following data: error: ${error.message}, userId: ${userId}`
      );
    },
  });

  const handleSubmit = () => {
    if (!name.trim()) {
      toast.error("Legal name is required");
      return;
    }
    updateMutation.mutate();
  };

  return (
    <Modal
      id="updateLegalNameModal"
      aria-labelledby="update-legal-name-modal-title"
      centered
      show={isVisible}
      onHide={onClose}
    >
      <Modal.Body>
        <div className={styles.modalContainer}>
          <h2 id="update-legal-name-modal-title" className={styles.modalTitle}>
            Update legal name
          </h2>
          <p className={styles.modalDescription}>
            Changes are saved for this customer and recorded in the audit
            history.
          </p>
          <Form.Group className="mb-3">
            <Form.Label htmlFor="full_name">Legal name</Form.Label>
            <Form.Control
              id="full_name"
              type="text"
              value={name}
              onChange={(event) => setName(event.target.value)}
              required
              maxLength={191}
            />
          </Form.Group>
          <div className={styles.modalFooter}>
            <Button
              className={styles.submitButton}
              variant="success"
              size="lg"
              onClick={handleSubmit}
              disabled={updateMutation.isLoading}
            >
              {updateMutation.isLoading ? "Processing..." : "Update"}
            </Button>
            <Button
              className={styles.cancelButton}
              variant="secondary"
              size="lg"
              onClick={onClose}
            >
              Cancel
            </Button>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
}
